import React from 'react';
import PropTypes from 'prop-types';
import {
  expiresSoon,
  formatStatus,
  expiresSoonIcon,
  resolutionDate,
  formSubmissionStatus,
  hideStatus,
} from '../utilities/poaRequests';
import { recordDatalayerEvent } from '../utilities/analytics';
import KeyValueList from './KeyValueList';

const PROCESSED_PREFIXES = {
  declination: 'Request declined on',
  acceptance: 'Request accepted on',
  expiration: 'Request expired on',
};

const POARequestCard = ({ poaRequest }) => {
  const lastName = poaRequest?.powerOfAttorneyForm?.claimant?.name?.last;
  const firstName = poaRequest?.powerOfAttorneyForm?.claimant?.name?.first;
  const city = poaRequest?.powerOfAttorneyForm?.claimant?.address.city;
  const state = poaRequest?.powerOfAttorneyForm?.claimant?.address.stateCode;
  const zipCode = poaRequest?.powerOfAttorneyForm?.claimant?.address.zipCode;
  const requestedOrg = poaRequest?.powerOfAttorneyHolder?.name;
  const requestedRep =
    poaRequest?.accreditedIndividual?.fullName || 'None selected';
  const poaStatus =
    poaRequest.resolution?.decisionType || poaRequest.resolution?.type;
  const poaRequestSubmission =
    poaRequest?.powerOfAttorneyFormSubmission?.status;
  const cardData = {
    'Requested organization': requestedOrg,
    'Preferred representative': requestedRep,
    ...(poaRequest.resolution &&
      !hideStatus(poaRequestSubmission) && {
        [PROCESSED_PREFIXES[poaStatus]]: resolutionDate(
          poaRequest.resolution?.createdAt,
          poaRequest.id,
        ),
      }),
    ...(!poaRequest.resolution && {
      'Request submitted on': Object.freeze(
        <>
          {expiresSoonIcon(poaRequest.expiresAt) && (
            <va-icon
              class="poa-request__card-icon"
              icon="warning"
              size={2}
              srtext="warning"
              aria-hidden="true"
            />
          )}
          {resolutionDate(poaRequest.createdAt, poaRequest.id)}
          <span className="poa-request__card-field--expiry">
            {expiresSoon(poaRequest.expiresAt)}
          </span>
        </>,
      ),
    }),
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles
    <li role="listitem">
      <va-card class="poa-request__card">
        <h3
          className="vads-u-margin--0 vads-u-display--flex vads-u-flex-direction--column vads-u-align-items--flex-start"
          aria-labelledby={`${
            hideStatus(poaRequestSubmission)
              ? ``
              : `poa-request-card-${poaRequest.id}-status`
          } poa-request-card-${poaRequest.id}-name`}
        >
          {!hideStatus(poaRequestSubmission) && (
            <span
              id={`poa-request-card-${poaRequest.id}-status`}
              data-testid={`poa-request-card-${poaRequest.id}-status`}
              className="usa-label poa-request__card-field poa-request__card-field--status status status--processing vads-u-font-weight--normal vads-u-font-family--sans"
            >
              {formatStatus(poaStatus)}
            </span>
          )}
          <span
            id={`poa-request-card-${poaRequest.id}-name`}
            data-testid={`poa-request-card-${poaRequest.id}-name`}
            className="poa-request__card-title"
          >
            {`${lastName}, ${firstName}`}
          </span>
        </h3>
        <p className="poa-request__card-field">
          <span data-testid={`poa-request-card-${poaRequest.id}-city`}>
            {city}
          </span>
          {', '}
          <span data-testid={`poa-request-card-${poaRequest.id}-state`}>
            {state}
          </span>
          <span data-testid={`poa-request-card-${poaRequest.id}-zip`}>
            {' '}
            {zipCode}
          </span>
        </p>
        <KeyValueList data={cardData} className="vads-u-margin-top--1p5" />
        {formSubmissionStatus(poaRequestSubmission)}
        {poaRequest.canAccept !== false && (
          <va-link
            active
            disable-analytics
            href={`/representative/representation-requests/${poaRequest.id}`}
            onClick={recordDatalayerEvent}
            data-eventname="arp-card"
            text="View representation request"
            label={`View representation request for ${lastName}, ${firstName}`}
            class="vads-u-display--block vads-u-margin-top--1p5"
          />
        )}
      </va-card>
    </li>
  );
};

POARequestCard.propTypes = {
  cssClass: PropTypes.string,
  id: PropTypes.string,
  poaRequest: PropTypes.object,
};

export default POARequestCard;
